module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/runtime.lex.v2-2020-08-07.paginators.json
// module id = 1585
// module chunks = 3